import { useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import API from "../utils/API"
import ButtonCollapse from "./ButtonCollapse"
import ButtonRefresh from "./ButtonRefresh"
import LoadingCard from "./LoadingCard"
import DisplayManageDetailsForm from "./DisplayManageDetailsForm"
import Sweetalert from "../utils/Sweetalert"

export default function DisplayManageDetails({ displayId }) {
  // State
  const navigate = useNavigate()
  const [display, setDisplay] = useState(null)
  const [loaded, setLoaded] = useState(false)
  const [editDisplay, setEditDisplay] = useState(false)

  // Comportements
  const getDisplay = (id) => {
    API.GET("/display/" + id, (response) => {
      setDisplay(response.data)
      setLoaded(true)
    })
  }

  useMemo(() => {
    getDisplay(displayId)
  }, [displayId])

  const updateDisplay = (data) => {
    let displayCopy = { ...display, ...data }
    setDisplay(displayCopy)
  }

  const handleDelete = () => {
    Sweetalert.fireConfirm(
      "Êtes-vous sûr de vouloir supprimer cet emplacement ?",
      "Cette action est irréversible",
      () => {
        API.DELETE("/admin/display/" + displayId, (response) => {
          Sweetalert.fireSuccessToast(response.data.message)
          navigate("/display/gestion")
        })
      }
    )
  }

  // Rendu
  return (
    <>
      <div className="row">
        <div className="col-xl-4">
          <div className="card card-outline card-primary">
            <div className="card-header">
              <h3 className="card-title">Informations</h3>
              <div className="card-tools">
                <ButtonRefresh onClick={() => getDisplay(displayId)} />
                <ButtonCollapse />
              </div>
            </div>
            <div className="card-body" style={{ display: "block" }}>
              <LoadingCard loaded={loaded}>
                {display && (
                  <>
                    <div className="row">
                      <div className="col-6">
                        <strong>Code</strong>
                      </div>
                      <div className="col-6">{display.code || "-"}</div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-6">
                        <strong>Agence</strong>
                      </div>
                      <div className="col-6">{display.agency || "-"}</div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-6">
                        <strong>Type</strong>
                      </div>
                      <div className="col-6">
                        <span className={`badge badge-${display.type === "Digital" ? "success" : "secondary"}`}>
                          {display.type || "-"}
                        </span>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-6">
                        <strong>Format</strong>
                      </div>
                      <div className="col-6">{display.format || "-"}</div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-6">
                        <strong>Secteur</strong>
                      </div>
                      <div className="col-6">{display.sector || "-"}</div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-6">
                        <strong>Adresse</strong>
                      </div>
                      <div className="col-6">{display.address || "-"}</div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-6">
                        <strong>Ville</strong>
                      </div>
                      <div className="col-6">
                        {display.zip_code && `${display.zip_code} `}
                        {display.city || "-"}
                      </div>
                    </div>
                    {(display.lat || display.long) && (
                      <>
                        <hr />
                        <div className="row">
                          <div className="col-6">
                            <strong>Coordonnées</strong>
                          </div>
                          <div className="col-6">
                            {display.lat}, {display.long}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </LoadingCard>
            </div>
            <div className="card-footer">
              <button type="button" className="btn btn-primary" onClick={() => setEditDisplay(true)}>
                <i className="far fa-edit"></i> Éditer
              </button>
              <button type="button" className="btn btn-danger float-right" onClick={handleDelete}>
                <i className="fas fa-trash"></i> Supprimer
              </button>
            </div>
          </div>
        </div>
        <div className="col-xl-8">
          {editDisplay && display ? (
            <DisplayManageDetailsForm display={display} updateDisplay={updateDisplay} setEditDisplay={setEditDisplay} />
          ) : (
            <div className="card card-outline card-info">
              <div className="card-header">
                <h3 className="card-title">Détails complets</h3>
                <div className="card-tools">
                  <ButtonCollapse />
                </div>
              </div>
              <div className="card-body" style={{ display: "block" }}>
                <LoadingCard loaded={loaded}>
                  {display && (
                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <strong>Indoor :</strong> {display.indoor || "-"}
                        </p>
                        <p>
                          <strong>Position :</strong> {display.position || "-"}
                        </p>
                        <p>
                          <strong>Audience :</strong> {display.audience || "-"}
                        </p>
                        <p>
                          <strong>Spot :</strong> {display.spot || "-"}
                        </p>
                        <p>
                          <strong>Diffusion :</strong> {display.diffusion || "-"}
                        </p>
                        <p>
                          <strong>TLPE :</strong> {display.tlpe || "-"}
                        </p>
                        <p>
                          <strong>Zone type :</strong> {display.zone_type || "-"}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong>Prix 1 :</strong> {display.price_1 ? `${display.price_1}€` : "-"}
                        </p>
                        <p>
                          <strong>Prix 2 :</strong> {display.price_2 ? `${display.price_2}€` : "-"}
                        </p>
                        <p>
                          <strong>Prix 3 :</strong> {display.price_3 ? `${display.price_3}€` : "-"}
                        </p>
                        <p>
                          <strong>Commercial :</strong> {display.commercial || "-"}
                        </p>
                        <p>
                          <strong>Téléphone :</strong> {display.tel || "-"}
                        </p>
                      </div>
                    </div>
                  )}
                </LoadingCard>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
